<ng-container [ngSwitch]="showStoreSettingsPanel">
  <ng-container *ngSwitchCase="false">
    <card [formGroup]="form">
      <div header-title class="gap-2">
        {{ 'cards.clients.store_settings.title' | translate}}
        <status-circle
          [status]="storeSettingsStatus"
          enum="StatusCircleStatus"
        ></status-circle>
      </div>
      <div header-actions>
        <lxm-button
          type="beige"
          [label]="'cards.clients.store_settings.action.invite_to_store' | translate"
          (click)="onInviteToStoreClick()"
          [disabled]="!canEdit || !isClientActive || !canEditClientStoreSettings"
        ></lxm-button>
      </div>
    </card>
  </ng-container>

  <ng-container *ngSwitchCase="true">
    <card-expanding [formGroup]="form">
      <div header-title class="gap-2">
        {{ 'cards.clients.store_settings.title' | translate}}
        <status-circle
          [status]="storeSettingsStatus"
          enum="StatusCircleStatus"
        ></status-circle>
      </div>
      <div header-actions>
        <ng-container [ngSwitch]="edit">
          <ng-container *ngSwitchCase="false">
            <lxm-button
              type="beige"
              icon="edit"
              title="action.edit"
              (click)="toggleEdit()"
              *ngIf="canEditClientStoreSettings"
            ></lxm-button>
          </ng-container>
          <ng-container *ngSwitchCase="true">
            <lxm-button
              type="grey"
              icon="back"
              label="action.cancel"
              (click)="toggleEdit()"
            ></lxm-button>
            <lxm-button
              type="beige"
              icon="save"
              label="action.save"
              [loading]="saveLoading"
              (click)="save()"
              buttonType="submit"
            ></lxm-button>
          </ng-container>
        </ng-container>
      </div>

      <div body>
        <div class="row">
          <div class="col-12 no-padding">
            <form-field
              label="cards.clients.store_settings.label.is_store_client"
              [readonly]="!edit"
            >
              <slide-toggle
                toggle
                for="isStoreClient"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="isStoreClient"></validation-errors>
            </form-field>

            <ng-container *ngIf="form.get('isStoreClient').value">
              <form-field
                label="cards.clients.store_settings.label.discount_percentage"
                [readonly]="!edit"
              >
                <lxm-input
                  for="discountPercentage"
                  [readonly]="!edit"
                  type="percent"
                ></lxm-input>
                <validation-errors for="discountPercentage"></validation-errors>
              </form-field>

            </ng-container>
          </div>
        </div>
      </div>
    </card-expanding>
  </ng-container>
</ng-container>
